import { createContext, useContext } from "react";

export interface SideBySideNotAllowed {
    /** boolean flag to indicate side by side view is not allowed */
    isSideBySideAllowed: false;
}

export interface SideBySideAllowed {
    /** boolean flag to indicate side by side view is allowed (e.g., document entry) */
    isSideBySideAllowed: true;
    /** boolean flag to indicate if side by side view is currently enabled */
    isSideBySideEnabled: boolean;
    /** callback to toggle side by side on/off */
    toggleSideBySide: () => void;
    /** boolean flag to indicate the side by side button is disabled (e.g., document entry file size exceeded) */
    isSideBySideButtonDisabled: boolean;
    /** callback to disable the side by side button (e.g., when document entry file size is exceeded) */
    disableSideBySideButton: () => void;
}

export type SideBySideContextType = SideBySideNotAllowed | SideBySideAllowed;

export const SideBySideContext = createContext<SideBySideContextType>({
    isSideBySideAllowed: false,
});

/**
 * Returns the side-by-side layout state and toggle callback
 */
export const useSideBySide = () => useContext(SideBySideContext);
